module.exports = __webpack_public_path__ + "static/media/heattread-logo.5f2e2b63.jpg";